export var Identity;
(function (Identity) {
  Identity["privatperson"] = "privatperson";
  Identity["unternehmen"] = "unternehmen";
  Identity["partner"] = "partner";
  // nicht eingeloggt
  Identity["nobody"] = "nobody";
})(Identity || (Identity = {}));
export var AccountTyp;
(function (AccountTyp) {
  AccountTyp["hauptaccount"] = "hauptaccount";
  AccountTyp["subaccount"] = "subaccount";
})(AccountTyp || (AccountTyp = {}));
//# sourceMappingURL=identity.js.map
